import { get } from './get';
import { list } from './list';

export type {
  RulesExecutionLogsQuery,
  RulesExecutionLogsResponse,
} from './list';

export const rulesExecutionLogs = {
  get,
  list,
};
